import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import $ from "jquery";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { formatNumber, isNumeric } from "../../helpers/formater";
import { useTranslation } from "react-i18next";

const InvoiceAchatDetails = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();

  const [client, setClient] = useState([]);
  const [invoiceCreateDate, setInvoiceCreateDate] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [clientToEditId, setClientToEditId] = useState(0);
  const [invoice, setInvoice] = useState([]);
  const [objet, setObjet] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [qty, setQty] = useState(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [unitPrice, setUnitPrice] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState([]);

  //invoice status history
  const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);
  const [invoiceProductsToDelete, setInvoiceProductsToDelete] = useState([]);
  const [reloadState, setReloadState] = useState(0);

  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //facture achat
  const [product, setProduct] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [purchaseAccount, setPurchaseAccount] = useState([]);
  const [remarque, setRemarque] = useState([]);
  const remarqueRef = useRef("");
  const [invoiceId, setInvoiceId] = useState("");
  const [attachementRecu, setAttachementRecu] = useState("");

  useEffect(() => {
    calcInvoiceSummary();
  }, [invoiceProductsState]);
  const calcInvoiceSummary = () => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].total_ht);
      totalTtc += parseFloat(invoiceProductsState[i].total_ttc);
      totalTva +=
        parseFloat(invoiceProductsState[i].total_ttc) -
        parseFloat(invoiceProductsState[i].total_ht);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };
  const getProductData = async (selectedProduct) => {
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        setQty(0);
        setUnitPrice(response.data.data[0]["sellingPrice"]);
        setTva(response.data.data[0]["taxe_vente"].rate);
      })
      .catch((error) => console.log("error " + error));
  };
  const transformArrayToOptions4Products = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
        value: target[i].id,
        label: target[i].name,
        rate: target[i].taxe_achat.rate,
      };
      array.push(obj);
    }
    return array;
  };
  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = { value: target[i].id, label: target[i].companyName };
      array.push(obj);
    }
    return array;
  };
  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedProducts();

    getInvoiceStatusHistory();
    getInvoiceProducts();
    getAllAssociatedProducts();
    calcInvoiceSummary();
    getInvoiceStatus();
    getAccounts();
  }, []);

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedProducts();

    getInvoiceStatusHistory();
    getInvoiceProducts();
    calcInvoiceSummary();
    getInvoiceStatus();
    getAccounts();
  }, [reloadState]);

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };
  const getInvoiceStatusHistory = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/invoice_achats_status_history/${id}`)
      .then((response) => {
        setInvoiceStatusHistory(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = { value: products[i].id, label: products[i].name };
      array.push(obj);
    }
    return array;
  };

  const getInvoiceProducts = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/facture_achats_products/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setInvoiceProductsState(response.data.data);
          console.log("setInvoiceProductsState: ", response.data.data);
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const getSelectedInvoiceClientId = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/factures/byid/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setInvoice(response.data.data);
          setClientToEditId(response.data.data.client_id);
          setData(response.data.data);
          console.log("cliets:", clients);
          // setClient([
          //     {
          //         "value": 137,
          //         "label": "Aliquam ullamco even Laboris aliqua Aliq"
          //     },
          //     {
          //         "value": 138,
          //         "label": "Ea veniam est prae Velit aut lorem ips"
          //     },
          //     {
          //         "value": 141,
          //         "label": "Fuga Optio enim au Cillum natus consect"
          //     },
          //     {
          //         "value": 142,
          //         "label": "Sint sunt quo ut lab Exercitation consequ"
          //     }
          // ].filter(c => c.value === response.data.data.client_id));
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let selectedProduct = [];
    selectedProduct = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );
    console.log(
      "selected product on click edit: ",
      selectedProduct[0].product.sellingPrice,
    );
    setTva(selectedProduct[0].tva);
    setQty(selectedProduct[0].qty);
    setUnitPrice(selectedProduct[0].product.sellingPrice);
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        setInvoiceProductsToDelete([...invoiceProductsToDelete, productId]);
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
    const successMessage = "le produit a été supprimer avec succés";
    toast.success(successMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const getAllAssociatedProducts = async () => {
    let fst = {};
    let snd = {};
    let res_suppliers_response = {};
    let res_purchaseAccount_response = {};
    let res = {};
    let suppliers_response = {};
    let purchaseAccount_response = {};

    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformArrayToOptions4Products(response.data.data));
        fst = transformArrayToOptions4Products(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );

    const response2 = await jwtInterceoptor
      .get(`/data/user/factures_achat/byid/${id}`)
      .then((res) => {
        snd = res.data.data;

        setInvoice(res.data.data);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));

    const response3 = await axios
      .get(
        baseURL +
          `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      )
      .then((res) => {
        console.log("data ", res.data.data);
        setSuppliers(transformArrayToOptions(res.data.data));
        suppliers_response = transformArrayToOptions(res.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );

    res_suppliers_response = suppliers_response.filter(
      (s) => s.value === snd.supplier_id,
    );

    setSupplier({
      value: res_suppliers_response[0]["value"],
      label: res_suppliers_response[0]["label"],
    });
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    //reset value to default
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTva(0);
  };

  const emptyStates = () => {
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTva(0);
  };
  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const addNewProductToInvoice = async () => {
    emptyStates();
    if (selectedProduct.value === null || qty === 0) {
      const errorMessage = "Tous les champs sont obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        const errorMessage = "Le produit déja exist !";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        /**
         * prepare product
         * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
         */
        let product = {
          product_id: singleSelectedProduct.value,
          product: {
            name: singleSelectedProduct.label,
            sellingPrice: unitPrice,
          },
          qty: qty,
          tva: tva,
          total_ht: leTotalHt.current.value,
          total_ttc: leTotalTTc.current.value,
        };
        setInvoiceProductsState([...invoiceProductsState, product]);
        console.log("after click add new product, producs state is : ", [
          ...invoiceProductsState,
          product,
        ]);
      }
    }
  };

  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = {
        value: clients[i].id,
        label: clients[i].name + " " + clients[i].lastName,
      };
      array.push(obj);
    }
    return array;
  };
  const setData = (invoice) => {
    setQty(invoice.qty);
    setInvoiceDueDate(invoice.due_date);
    setInvoiceCreatedAt(invoice.created_at);
    setRemarque(invoice.remarque);
    setUnitPrice(invoice.price_ut);
    setSummaryTotatlHt(invoice.total);
    setSummaryTotatlTtc(invoice.total_ttc);
    setSummaryTotalTva(invoice.total_tva);
    setInvoiceId(`Fact-achat-${formatNumber(invoice.id)}`);
    setInvoiceNumber(invoice.invoice_number);
  };

  const save = async () => {
    // check if all tab 1 inputs are !impty
    let isOkToEdit = true;
    isOkToEdit = !(
      client.length === 0 ||
      invoiceDueDate.length === 0 ||
      invoiceProductsState.length === 0 ||
      objet.length === 0
    );
    console.log("1st: ", isOkToEdit);

    //etat= payé
    if (selectedStatus === "2" && paymentType.length === 0) {
      isOkToEdit = false;
    }
    if (selectedStatus === "2" && paymentType.length !== 0) {
      if (banquePaymentOption.length === 0) {
        isOkToEdit = false;
      } else {
        if (banquePaymentOption === "chéque" && chequeId.length === 0) {
          isOkToEdit = false;
        }
      }
    }

    console.log("2nd: ", isOkToEdit);

    //etat = payé en partie
    if (selectedStatus === "3" && paymentType.length === 0) {
      isOkToEdit = false;
    }
    if (selectedStatus === "3" && paymentType.length !== 0) {
      if (banquePaymentOption.length === 0) {
        isOkToEdit = false;
      } else {
        if (banquePaymentOption === "chéque" && chequeId.length === 0) {
          isOkToEdit = false;
        }
      }
    }
    console.log("3th: ", isOkToEdit);

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0
    ) {
      isOkToEdit = false;
    }
    console.log("4th: ", isOkToEdit);

    // console.log("selectedStatus !== '0': ", client)
    // console.log("selectedStatus !== '0': ", client[0].value)
    // isOkToEdit=false;
    if (isOkToEdit) {
      let preparedProducts = [];
      let statusIsChanged = false;
      for (let i = 0; i < invoiceProductsState.length; i++) {
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].product.sellingPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].total_ht,
          total_ttc: invoiceProductsState[i].total_ttc,
          tva: invoiceProductsState[i].tva,
          reference: Math.random().toString(36).substring(2, 7),
        };
        preparedProducts.push(obj);
      }
      /**
       * preparedProducts = [
       *     {
       *         "product_id": 96,
       *         "price_unit_ht": 1250,
       *         "qty": 2,
       *         "total_ht": 2500,
       *         "total_ttc": 3000,
       *         "tva": 20
       *     },
       *     {
       *         "product_id": 97,
       *         "price_unit_ht": 100,
       *         "qty": "1",
       *         "total_ht": "100",
       *         "total_ttc": "110",
       *         "tva": 10
       *     }
       * ]
       */
      statusIsChanged = !(selectedStatus.length === 0);

      const newStatusHistory = {
        statusIsChanged: statusIsChanged,
        status_id: selectedStatus,
        payment_account_id: paymentType,
        banquePaymentOption: banquePaymentOption,
        chequeId: chequeId,
        payed_amount: payedAmount,
      };

      let clientID = 0;

      const prepareObject = {
        invoice_id: id,
        client_id: client.value,
        total_ht: summaryTotatlHt,
        total_ttc: summaryTotatlTtc,
        total_tva: summaryTotalTva,
        title: objet,
        due_date: invoiceDueDate,
        products: preparedProducts,
        newStatusHistory: newStatusHistory,
        invoiceProductsToDelete: invoiceProductsToDelete,
      };

      const response = await jwtInterceoptor
        .post(baseURL + `/data/user/facture_vente/edit`, prepareObject)
        .then((response) => {
          Swal.fire(
            "La facture de vente a été modifiée avec succès.",
            "",
            "success",
          );
          console.log("************* after save edit, ", response.data.data);
          setReloadState(1);
        })
        .catch((error) => console.log("error " + error));
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const downloadPJ = async () => {
    try {
      const response = await jwtInterceoptor.get(
        `/data/download/factures_achat/${id}`,
        { responseType: "arraybuffer" },
      );
      if (response.status === 200) {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Piéce facture achat no-${formatNumber(id)}`;
        link.click();
      } else {
        Swal.fire(
          t("Oops"),
          t("Une erreur s'est produite, réessayez"),
          "error",
        );
      }
    } catch (e) {
      Swal.fire(t("Oops"), t("le fichier n'existe pas"), "error");
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);

  // Fonction pour gérer la sélection du fichier
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Fonction pour envoyer le fichier au backend
  const handleSubmit = async (idpai) => {
    if (!selectedFile) {
      toast.error("Veuillez sélectionner un fichier");
      return;
    }

    const formData = new FormData();
    formData.append("recu", selectedFile);

    try {
      const response = await jwtInterceoptor.post(
        baseURL + `/data/importer/factureAchat/${idpai}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Reçu a été importer avec succès !");
        setSelectedFile();
      } else {
        toast.error("Erreur lors de l'importation");
      }
    } catch (error) {
      console.error("Erreur:", error);
      toast.error("Erreur lors de l'importation");
    }
  };
  //// la fonction de dowland Recu
  const downloadRecu = async (idPaiement) => {
    try {
      const response = await jwtInterceoptor.get(
        `${baseURL}/data/download/factureAchat/${idPaiement}`,
        {
          responseType: "blob", // Ensures we receive the file in binary format
        },
      );

      // Extract content type from headers to determine the file type
      const contentType = response.headers["content-type"];
      const fileExtension = contentType.split("/")[1]; // Get the file extension (e.g., 'pdf' or 'jpeg')

      // Create a blob and link to download the file
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: contentType }),
      );
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;

      // Dynamically set the download file name with the correct extension
      fileLink.setAttribute("download", `recu_${idPaiement}.${fileExtension}`);

      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();

      toast.success("Reçu a été télécharger avec succès !");
    } catch (error) {
      console.error("Erreur lors du téléchargement du reçu:", error);
      toast.error("Erreur lors du téléchargement du reçu");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="row" style={{ zIndex: 1 }}>
          <div className="col-lg-12">
            <div class="page-header">
              <h1 class="page-title">{t("Détail de la facture")}</h1>
              <div>
                <ol className="breadcrumb">
                  <li
                    className="breadcrumb-item active"
                    onClick={() => {
                      navigate("/achat/factureachat/list");
                    }}
                  >
                    Liste des factures d'achat liée au stock
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    details
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-md-12 card">
            <div className="card-body" style={{ overflowX: "auto" }}>
              <div class="col-xl-12">
                <div class="panel panel-primary">
                  <div class="panel-body tabs-menu-body">
                    <div class="tab-content">
                      <div class="tab-pane active">
                        <div className="row">
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <label htmlFor="exampleInputEmail1" className="">
                              Facture no:
                            </label>
                            <input
                              type={"text"}
                              disabled={true}
                              className="form-control"
                              value={
                                isNumeric(invoiceNumber)
                                  ? `Fact-achat-${formatNumber(invoiceNumber)}`
                                  : invoiceNumber
                              }
                            />

                            {invoice?.bon_commande && (
                              <>
                                <br/>
                                <label className="">
                                  Référence du bon de commande :
                                </label>

                                <input
                                  type="text"
                                  disabled={true}
                                  className="form-control"
                                  value={invoice.bon_commande.title}
                                />
                              </>
                            )}
                          </div>
                        </div>
                        <br />
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                fournisseur
                              </label>
                              <Select
                                value={supplier}
                                options={suppliers}
                                onChange={(choice) => setSupplier(choice)}
                                isDisabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                date d'échéance
                              </label>
                              <input
                                type="date"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceDueDate(e.target.value)
                                }
                                value={invoiceDueDate}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                date de facture
                              </label>
                              <input
                                type="text"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceCreatedAt(e.target.value)
                                }
                                value={moment(invoiceCreatedAt).format(
                                  "YYYY-MM-DD",
                                )}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">DÉTAILS DE L’ARTICLE</th>
                              <th scope="col">COMPTE DE CHARGE DE L'ARTICLE</th>
                              <th scope="col">QUANTITÉ</th>
                              <th scope="col">PU HT</th>
                              <th scope="col">TVA %</th>
                              <th scope="col">Total HT</th>
                              <th scope="col">Total TTC</th>
                            </tr>
                          </thead>

                          {invoiceProductsState.map((product) => {
                            return (
                              <tr key={product.product_id}>
                                <td>
                                  {product.product.name}
                                  {product.details !== ""
                                    ? "-" + product.details
                                    : ""}
                                </td>
                                <td>
                                  {product.product.purchase_account.name +
                                    " - " +
                                    product.product.purchase_account.code}
                                </td>
                                <td>{product.qty}</td>
                                <td>
                                  {Number(
                                    product.total_ht / product.qty,
                                  ).toFixed(2)}
                                </td>
                                <td>{Number(product.tva) + "%"}</td>
                                <td>{Number(product.total_ht).toFixed(2)}</td>
                                <td>{Number(product.total_ttc).toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </table>

                        <div className="d-flex flex-row-reverse">
                          <div className="invoiceSummary">
                            <table>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total HT :
                                </td>
                                <td>
                                  {Number(summaryTotatlHt).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TVA :
                                </td>
                                <td>
                                  {Number(summaryTotalTva).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TTC :
                                </td>
                                <td>
                                  {Number(summaryTotatlTtc).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6"></div>
                          <div className="col-6 d-flex flex-row-reverse">
                            <button
                              onClick={downloadPJ}
                              className="btn btn-sm"
                              style={{
                                backgroundColor: "#f1461d",
                                color: "white",
                              }}
                            >
                              <i className="fe fe-download"></i> Télécharger la
                              Pièce
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-12">
            <div class="tab-pane">
              <div className="">
                <div class="container">
                  <ul class="notification">
                    {invoiceStatusHistory.map((invoiceStatus) => {
                      if (invoiceStatus.status.name === "Payé en partie") {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Mantant Payé: " +
                                        Number(
                                          invoiceStatus.payed_amount,
                                        ).toFixed(2) +
                                        organisation?.currency?.code}
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Réste à payé: " +
                                        Number(invoiceStatus.rap).toFixed(2) +
                                        organisation?.currency?.code}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption ===
                                            null
                                          ? ""
                                          : invoiceStatus.banquePaymentOption +
                                            (invoiceStatus.chequeId === null ||
                                            invoiceStatus.chequeId === ""
                                              ? ""
                                              : " - " + invoiceStatus.chequeId)}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13 text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}
                                    {invoiceStatus.status !== 1 && (
                                      <>
                                        <p>Recu de paiement :</p>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-sm "
                                            style={{
                                              backgroundColor: "#f1461d",
                                              color: "white",
                                            }}
                                            onClick={() =>
                                              downloadRecu(invoiceStatus.id)
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              download
                                            </span>
                                          </button>

                                          <input
                                            type="file"
                                            onChange={handleFileChange}
                                            id="fileInput"
                                            className="d-none"
                                            accept="image/*, .pdf"
                                          />
                                          <button
                                            className="btn btn-sm btn-warning"
                                            onClick={() =>
                                              document
                                                .getElementById("fileInput")
                                                .click()
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              publish
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() =>
                                              handleSubmit(invoiceStatus.id)
                                            }
                                            hidden={!selectedFile}
                                          >
                                            <span class="material-symbols-outlined">
                                              save
                                            </span>
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }
                      if (invoiceStatus.status.name === "Payé") {
                        console.log(invoiceStatus);
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption +
                                              " - " +
                                              invoiceStatus.chequeId ===
                                            null
                                          ? ""
                                          : invoiceStatus.chequeId}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13  text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}
                                    {invoiceStatus.status !== 1 && (
                                      <>
                                        <p>Recu de paiement :</p>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-sm"
                                            style={{
                                              backgroundColor: "#f1461d",
                                              color: "white",
                                            }}
                                            onClick={() =>
                                              downloadRecu(invoiceStatus.id)
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              download
                                            </span>
                                          </button>

                                          <input
                                            type="file"
                                            onChange={handleFileChange}
                                            id="fileInput"
                                            className="d-none"
                                            accept="image/*, .pdf"
                                          />
                                          <button
                                            className="btn btn-sm btn-warning"
                                            onClick={() =>
                                              document
                                                .getElementById("fileInput")
                                                .click()
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              publish
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() =>
                                              handleSubmit(invoiceStatus.id)
                                            }
                                            hidden={!selectedFile}
                                          >
                                            <span class="material-symbols-outlined">
                                              save
                                            </span>
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      } else {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="offcanvas offcanvas-bottom addProductCanvas"
          tabIndex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel">
              Renseigner le produit à ajouter.
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="fe fe-x fs-18"></i>
            </button>
          </div>
          <div class="offcanvas-body">
            <div id="all-fields-are-required">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Tous les champs sont obligatoire !
                </span>
              </div>
              <br />
            </div>

            <div id="warning-product-already-exists">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Le produit déja exist !
                </span>
              </div>
              <br />
            </div>

            <div id="qty-is-higher">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> L'article choisie est en rupture
                  de stock
                </span>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceAchatDetails;
